export const SIDEBAR_MENU_SUB_INDENT = 16;
export const INSERTION_BUTTON_SIZE = 12;

export const DRAG_ACTIVATION_DISTANCE = 8;
export const DROP_AFTER_ZONE_PX = 4;
export const AUTO_EXPAND_DELAY_MS = 700;

export const LEFT_NAV_DEFAULT_WIDTH = 293;
export const LEFT_NAV_MIN_WIDTH = 240;
export const LEFT_NAV_MAX_WIDTH = 480;
